module.exports = __webpack_public_path__ + "img/procure-aqui.94edc354.svg";